/* eslint-disable no-console */
import { ApolloLink } from '@apollo/client';

/**
 * adds operaion name to header for rate limiting
 */
export default new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      ...operation?.getContext()?.headers,
      'x-gql-op': operation.operationName,
    },
  });
  return forward(operation);
});
